module.exports = __webpack_public_path__ + "img/no2.48586b67.svg";